const forms = {
  onRequest: "Dalam permintaan", // translated 
  person: "orang", // translated 
  travelDate: "Tanggal perjalanan", // translated 
  travelDates: "Tanggal Perjalanan", // translated 
  cancel: "Membatalkan", // translated 
  getPrice: "Dapatkan Harga", // translated 
};



export default forms;
